var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('PreferenceConfigList',{attrs:{"program-id":_vm.programId},model:{value:(_vm.classificationConfig),callback:function ($$v) {_vm.classificationConfig=$$v},expression:"classificationConfig"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }